module.exports = __webpack_public_path__ + "img/gh-12132nut.prt.619c1abd.jpg";